import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "help-table-row__cell" }
const _hoisted_2 = { class: "help-table-row__cell" }
const _hoisted_3 = { class: "help-table-row__cell" }

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { PdfLink } from "@/components/modules";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  name?: string;
  file?: {
    name?: string;
    href?: string;
    target?: "_self" | "_blank" | "_parent" | "_top";
  };
  size?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'help-table-row',
  props: {
    modifires: { type: [String, Array, Boolean] },
    name: {},
    file: { default: () => ({}) },
    size: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('help-table-row', _ctx.modifires))
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.name), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(PdfLink), {
        href: props.file.href,
        download: props.file.name,
        target: props.file.target
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.file.name), 1)
        ]),
        _: 1
      }, 8, ["href", "download", "target"])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.size), 1)
  ], 2))
}
}

})